import React, { useState, useEffect, useCallback, useContext } from "react";
// import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import AddMunch from "./addMunch";
import { ConfirmTemplate } from "../../../components/confirm";
import { useAlert } from "react-alert";
import { ApiService } from "../../../services/ApiService";
import { muchAndLearnMngtThunk } from "../../../store/actions/trainingmanagement/training.thunk";
import useModal from "../../../utils/useModal";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import Slider from "react-slick";
import EditMunch from "./edit_munch";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { AuthContext } from "../../../Context/AuthContext";
import moment from "moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

Modal.setAppElement("#root");

export const TrainingIndex = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const [munch, setMunch] = useState({});
  const [activeMuncg, setActiveMunch] = useState({});
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const { modalIsOpen, openModal, closeModal } = useModal();
  const { muchAndLearn } = useSelector((state) => state.trainingMngt);
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  const getAllMuchAndLearns = useCallback(async () => {
    updateLoader(true, "Getting all munch and learn");
    await dispatch(muchAndLearnMngtThunk.getAllMuchAndLearn());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    setActiveMunch(muchAndLearn[0]);
  }, [muchAndLearn]);

  useEffect(() => {
    getAllMuchAndLearns();
  }, []);

  const editOpen = () => {
    setEditModalOpen(true);
  };

  const closeEdit = () => {
    setEditModalOpen(false);
  };

  const deleteRequest = (id) => {
    const request = async () => {
      const res = await ApiService.delete(
        `trainings/delete-munch-and-learn/${id}`
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getAllMuchAndLearns();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Munch And Learn",
        message: "Are You Sure You Want To Delete This Munch and Learn",
      },
      request
    );
  };
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <TrainingNavbar openModal={openModal} />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="add cases modal"
        >
          <AddMunch
            closeModal={closeModal}
            alert={alert}
            users={employees}
            getAllMuchAndLearn={getAllMuchAndLearns}
          />
        </Modal>
        <Modal
          isOpen={editModalOpen}
          onRequestClose={closeEdit}
          style={customStyles}
          contentLabel="add cases modal"
        >
          <EditMunch
            closeModal={closeEdit}
            alert={alert}
            users={employees}
            getAllMuchAndLearn={getAllMuchAndLearns}
            munch={munch}
          />
        </Modal>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="table-wrapper table-responsive">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-xs-12"
                      id="munch_learn_content_wrapper"
                    >
                      <div className="mb-3 clearfix">
                        <div
                          class="btn-group float-left"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary btn-group-sm"
                            onClick={() => window.print()}
                          >
                            Print
                          </button>
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-secondary btn-group-sm"
                            table="munch"
                            filename="MUNCH AND LEARN"
                            sheet="tablexls"
                            buttonText="Export to excel"
                          />
                        </div>
                      </div>
                      <div class="">
                        <table
                          id="munch"
                          class="table table-striped table-bordered learn-table"
                        >
                          <thead>
                            <tr>
                              <th class="th-sm">
                                <b> NO </b>
                              </th>
                              <th class="th-sm" style={{ width: "250px" }}>
                                <b> NAME </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> DUE DATE </b>
                              </th>
                              <th class="th-sm" style={{ width: "270px" }}>
                                <b> PRESENTATION TYPE </b>
                              </th>
                              <th class="th-sm" style={{ width: "270px" }}>
                                <b> TOPIC </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> EMAIL </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> DATE CREATED </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> STATUS </b>
                              </th>
                              {(user.data.user.roles &&
                                user.data.user.roles.name ===
                                "training manager") ||
                                user.data.user.roles.name === "human resource" ? (
                                <th class="th-sm notexport">
                                  <b>ACTION</b>
                                </th>
                              ) : null}
                            </tr>
                          </thead>
                          <tbody>
                            {muchAndLearn.map((munch, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{munch.name}</td>
                                <td> {moment(munch.due_date).format("ll")} </td>
                                <td>{munch.presentation_type}</td>
                                <td>{munch.topic}</td>
                                {munch.presentation_type === "paired" ? (
                                  <td>
                                    {munch.users_email
                                      .split("-")
                                      .map((emails) => `${emails},`)}
                                  </td>
                                ) : (
                                  <td> {munch.email}</td>
                                )}
                                <td>
                                  {" "}
                                  {moment(munch.created_at).format("ll")}{" "}
                                </td>
                                <td>
                                  {activeMuncg &&
                                    activeMuncg.id === munch.id ? (
                                    <div className="text-success">Active</div>
                                  ) : (
                                    <div className="text-danger">Inactive</div>
                                  )}
                                </td>
                                <td>
                                  {(user.data.user.roles &&
                                    user.data.user.roles.name ===
                                    "training manager") ||
                                    user.data.user.roles.name ===
                                    "human resource" ? (
                                    <div class="dropdown">
                                      <a
                                        href="#"
                                        class="dropdown-toggle card-drop arrow-none"
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <h3 class="m-0 text-muted">
                                          <i class="fa fa-ellipsis-v"></i>
                                        </h3>
                                      </a>
                                      <div
                                        class="dropdown-menu dropdown-menu-right"
                                        aria-labelledby="btnGroupDrop1"
                                      >
                                        <a
                                          className="dropdown-item"
                                          id="edit_munch"
                                          onClick={() => {
                                            const value = {
                                              id: munch.id,
                                              name: munch.name,
                                              presentation_type:
                                                munch.presentation_type,
                                              due_date: munch.due_date,
                                              email: munch.email,
                                              users_email: munch.users_email,
                                              topic: munch.topic,
                                            };
                                            setMunch(value);
                                            editOpen();
                                          }}
                                        >
                                          Edit
                                        </a>

                                        <a
                                          class="dropdown-item"
                                          onClick={() => {
                                            deleteRequest(munch.id);
                                          }}
                                        >
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  ) : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/index.js